import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import dayjs from 'dayjs'
import { useAgendaStore } from './agendaStore'

export const useDateStore = defineStore('date', () => {
    const agendaStore = useAgendaStore()
    const date = ref(dayjs())
    
    // Get user data from localStorage
    const getUserFromLocalStorage = () => {
        const userData = localStorage.getItem('user')
        console.log('userData', userData)
        return userData ? JSON.parse(userData) : { canForwardDays: 0, canBackwardDays: 1 }
    }
    
    const user = ref(getUserFromLocalStorage())
    
    // Ensure default values if properties are missing or invalid
    if (user.value.canBackwardDays === undefined || user.value.canBackwardDays === "") {
        user.value.canBackwardDays = "1";
    }
    if (user.value.canForwardDays === undefined || user.value.canForwardDays === "") {
        user.value.canForwardDays = "0";
    }
    
    console.log('user', user.value)
    
    const formattedDate = computed(() => {
        return date.value.format('DD/MM/YYYY')
    })

    const apiFormattedDate = computed(() => {
        return date.value.format('YYYY-MM-DD')
    })

    const refDatum = computed(() => {
        return date.value.format('YYYY-MM-DD')
    })

    const fakeDate = computed(() => {
        //if date is today, return refDatum
        if (dayjs(date.value).isSame(dayjs(), 'day')) {
            return refDatum.value;
        } else {
            return refDatumYesterday.value;
        }
    })

    const refDatumYesterday = computed(() => {
        return dayjs(refDatum.value).subtract(1, 'day').format('YYYY-MM-DD')
    })

    const canIncrement = computed(() => {
        // Check if we can go forward based on user settings
        const forwardDays = parseInt(user.value.canForwardDays)
        // Default to 0 if not specified
        return dayjs(date.value).isBefore(dayjs().add(forwardDays || 0, 'day'), 'day')
    })

    const canDecrement = computed(() => {
        // Check if we can go backward based on user settings
        const backwardDays = parseInt(user.value.canBackwardDays) || 1;
        
        // If we're in the future (after today), we should be able to go back to today
        if (dayjs(date.value).isAfter(dayjs(), 'day')) {
            return true;
        }
        
        // If we're on today and canBackwardDays is 0, we can't go back further
        if (backwardDays === 0) return false;
        
        // Otherwise, check the standard backward limit
        return dayjs(date.value).isAfter(dayjs().subtract(backwardDays, 'day'), 'day');
    })
    
    function increment() {
        agendaStore.selected = null;
        // Check if we reached the forward limit
        const forwardDays = parseInt(user.value.canForwardDays) || 0;
        if (!dayjs(date.value).isBefore(dayjs().add(forwardDays, 'day'), 'day')) {
            return;
        }
        date.value = dayjs(date.value).add(1, 'day');
    }

    function decrement() {
        agendaStore.selected = null;
        // Check if we reached the backward limit
        const backwardDays = parseInt(user.value.canBackwardDays) || 1;
        
        // If we're in the future (after today), we can always go back
        if (dayjs(date.value).isAfter(dayjs(), 'day')) {
            date.value = dayjs(date.value).subtract(1, 'day');
            return;
        }
        
        // If we're at today and canBackwardDays is 0, we can't go back
        if (backwardDays === 0) return;
        
        // Otherwise, check if we reached the standard backward limit
        if (!dayjs(date.value).isAfter(dayjs().subtract(backwardDays, 'day'), 'day')) {
            return;
        }
        
        date.value = dayjs(date.value).subtract(1, 'day');
    }

    return { date, increment, decrement, formattedDate, canIncrement, canDecrement, refDatum, refDatumYesterday, fakeDate, apiFormattedDate }
})
